import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Voy a tener que dejarlo llorar?',
  a: 'No. El método usa el "Semáforo del Llanto" para que siempre atiendas a tu hijo si hay angustia real.'
}, {
  q: '¿Sirve si hacemos colecho?',
  a: 'Sí, es totalmente adaptable a la cama compartida.'
}, {
  q: '¿Cuánto tiempo tardaré en ver resultados?',
  a: 'Los cambios biológicos suelen notarse a partir del tercer o cuarto día de consistencia.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 md:py-24 px-6 max-w-3xl mx-auto" data-id="element-15">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mb-12" data-id="element-16">
        <h2 className="text-3xl md:text-4xl font-serif text-charcoal" data-id="element-17">
          Preguntas Frecuentes
        </h2>
      </motion.div>

      <div className="space-y-4" data-id="element-18">
        {faqs.map((faq, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-white rounded-2xl border border-sand/30 overflow-hidden" data-id="element-19">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-20">
              <span className="font-serif text-lg text-charcoal font-medium" data-id="element-21">
                {faq.q}
              </span>
              <ChevronDown className={`text-terracotta transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-22" />
            </button>
            <AnimatePresence data-id="element-23">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-24">
                  <div className="px-6 pb-5 text-charcoal/70 leading-relaxed" data-id="element-25">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>)}
      </div>
    </section>;
};